module.exports = __webpack_public_path__ + "img/styria-tiskara-zagreb.152241fa.svg";